module.exports = __webpack_public_path__ + "static/media/office4.7325abbb.png";